// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35IhC","newExpiryDate":"styles_newExpiryDate__2GkYz","footer":"styles_footer__3_ELh"};